<div class="page-layout blank" fusePerfectScrollbar *ngIf="projectData.title">

    <div class="project-header mb-32">
        <div fxLayout="row" fxLayout.lt-md="column" fxFlex="80" fxFlex.lt-md="100" class="inner-container">
            <div fxLayout="row wrap" class="contact-image">
                <div fxLayoutAlign="center center" class="company-logo pr-24" [fxFlex]="isCompanyLogo ? 30 : 45" fxFlex.lt-md="100"
                    *ngIf="companyLogoUrl || bannerImgUrl">
                    <img [src]="bannerImgUrl" [ngClass]="{'company-logo':isCompanyLogo}" (error)="updateUrl($event)">
                </div>
                <div fxLayoutAlign="start center" class="p-24" [fxFlex]="isCompanyLogo ? 70 : 55" fxFlex.lt-md="100">
                    <div>
                        <h2>{{projectData.title | translate}}</h2>
                        <h4>{{projectData.positionName | translate}}</h4>
                        <span>{{getCity(projectData.cityName)}}</span>
                    </div>
                </div>
            </div>
            <div class="contanct-info pt-16 pb-24 px-24">
                <h2 class="text-center">{{ 'Apply for a Job' | translate }}</h2>
                <div fxLayout="row" fxLayoutAlign="center center" class="py-16">
                    <button mat-flat-button class="primary-50-bg" (click)="signInToProject()"
                        [disabled]="signedInAlready" fxFlex>
                        {{(signedInAlready ? 'Already applied':'I am signing up') | translate}}
                    </button>
                </div>
                <mat-divider *ngIf="projectData.ad_support_phone != ''" class="my-8"></mat-divider>
                <div fxLayout="row" *ngIf="projectData.ad_support_phone != ''" fxLayoutAlign="start center"
                    class="py-16">
                    <mat-icon class="s-40 mr-16">phone</mat-icon>
                    <div class="mr-16">
                        <div class="text-uppercase">{{ 'Or Apply by Phone' | translate }}</div>
                        <div class="phone-text">{{projectData.ad_support_phone}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="project-content pb-64">
        <div fxLayout="column" fxFlex="80" fxFlex.xs="85" class="inner-container">
            <h2 class="line">{{ 'Job description' | translate }}</h2>
            <div class="full-content" [innerHTML]="projectData.fullcontent">
            </div>
            <!-- <div class="py-24" *ngIf="projectDemogs.length > 0">
                <h2>{{ 'Workplace conditions' | translate }}</h2>
                <ul>
                    <li *ngFor="let demog of projectDemogs">
                        {{demog.name}}{{demog.pivot.value ? ': ':''}} {{demog.pivot.value}}
                    </li>
                </ul>
            </div> -->
            <div class="py-24" *ngIf="showSignInButton">
                <button mat-flat-button color="accent" (click)="signInToProject()"
                    [disabled]="signedInAlready">{{(signedInAlready ? 'Already applied':'I am signing up') | translate}}</button>
            </div>
        </div>
    </div>

</div>